/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceHighlight } from './EvidenceHighlight';
import {
  EvidenceHighlightFromJSON,
  EvidenceHighlightFromJSONTyped,
  EvidenceHighlightToJSON,
} from './EvidenceHighlight';

/**
 *
 * @export
 * @interface PatchedFindingWrite
 */
export interface PatchedFindingWrite {
  /**
   *
   * @type {number}
   * @memberof PatchedFindingWrite
   */
  riskIndicator?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedFindingWrite
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedFindingWrite
   */
  summary?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedFindingWrite
   */
  severity?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedFindingWrite
   */
  confidence?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedFindingWrite
   */
  explains?: Array<number>;
  /**
   *
   * @type {Array<object>}
   * @memberof PatchedFindingWrite
   */
  evidence?: Array<object>;
  /**
   *
   * @type {Array<EvidenceHighlight>}
   * @memberof PatchedFindingWrite
   */
  evidenceHighlights?: Array<EvidenceHighlight>;
  /**
   *
   * @type {boolean}
   * @memberof PatchedFindingWrite
   */
  reviewed?: boolean;
}

/**
 * Check if a given object implements the PatchedFindingWrite interface.
 */
export function instanceOfPatchedFindingWrite(value: object): value is PatchedFindingWrite {
  return true;
}

export function PatchedFindingWriteFromJSON(json: any): PatchedFindingWrite {
  return PatchedFindingWriteFromJSONTyped(json, false);
}

export function PatchedFindingWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedFindingWrite {
  if (json == null) {
    return json;
  }
  return {
    riskIndicator: json['risk_indicator'] == null ? undefined : json['risk_indicator'],
    title: json['title'] == null ? undefined : json['title'],
    summary: json['summary'] == null ? undefined : json['summary'],
    severity: json['severity'] == null ? undefined : json['severity'],
    confidence: json['confidence'] == null ? undefined : json['confidence'],
    explains: json['explains'] == null ? undefined : json['explains'],
    evidence: json['evidence'] == null ? undefined : json['evidence'],
    evidenceHighlights:
      json['evidence_highlights'] == null
        ? undefined
        : (json['evidence_highlights'] as Array<any>).map(EvidenceHighlightFromJSON),
    reviewed: json['reviewed'] == null ? undefined : json['reviewed'],
  };
}

export function PatchedFindingWriteToJSON(value?: PatchedFindingWrite | null): any {
  if (value == null) {
    return value;
  }
  return {
    risk_indicator: value['riskIndicator'],
    title: value['title'],
    summary: value['summary'],
    severity: value['severity'],
    confidence: value['confidence'],
    explains: value['explains'],
    evidence: value['evidence'],
    evidence_highlights:
      value['evidenceHighlights'] == null
        ? undefined
        : (value['evidenceHighlights'] as Array<any>).map(EvidenceHighlightToJSON),
    reviewed: value['reviewed'],
  };
}
